<template>
    <div>
          <app-header/>
        <!-- Page container -->
        <div class="page-container">
            <!-- Page content -->
            <div class="page-content">

                <!-- Main sidebar -->
                <app-sidebar/>
                <!-- /main sidebar -->
                
                <router-view></router-view>

            </div>
        </div>
        <!-- /page container -->
    </div>
</template>

<script>
import router from '@/router'
const token = localStorage.getItem('token')
const status = localStorage.getItem('status')
export default {
  name: 'GoAdmin',
  data () {
    return {

    }
  },
  mounted(){
  	// if (!token) {
  	// 	localStorage.removeItem('token')
  	// 	router.go('/')
  	// }
  }
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/GoAdmin.vue